import { render, staticRenderFns } from "./premiumGoodCategoryList.vue?vue&type=template&id=3badcea8&scoped=true"
import script from "./premiumGoodCategoryList.vue?vue&type=script&lang=js"
export * from "./premiumGoodCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3badcea8",
  null
  
)

export default component.exports